import React from 'react';

export default class ApplicablePaymentItem {
  constructor(item) {
    if (item) {
      this.CpId = item.cpId;
      this.CpLptdesc = item.cpLptdesc;
      this.CpPaymentDate = item.cpPaymentDate;
      this.CpAmountPaid = item.cpAmountPaid;
      this.CpBalance = item.cpBalance;
      this.CpRcycode = item.cpRcycode;
      return;
    }
    this.CpId = '';
    this.CpLptdesc = '';
    this.CpPaymentDate = '';
    this.CpAmountPaid = '';
    this.CpBalance = '';
    this.CpRcycode = '';
  }

  static MoneyFields = ['CpAmountPaid', 'CpBalance'];
  static DateFields = ['CpPaymentDate'];

  static Currency() {
    return 'CpRcycode';
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Selected', orderById: '', data: ApplicablePaymentItem.getSelectedCellContent, minWidth: 20 },
      { label: 'Client Payment ID', orderById: 'CpId', data: 'CpId', minWidth: 20 },
      {
        label: 'Payment Type',
        orderById: 'CpLptdesc',
        data: 'CpLptdesc',
        minWidth: 20
      },
      {
        label: 'Entry Date',
        orderById: 'CpPaymentDate',
        data: 'CpPaymentDate',
        minWidth: 40
      },
      { label: 'Amount Paid', orderById: 'CpAmountPaid', data: 'CpAmountPaid', minWidth: 20 },
      { label: 'Remaining Balance', orderById: 'CpBalance', data: 'CpBalance', minWidth: 20 }
    ];
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='radio'
          checked={item.Selected}
          onClick={(e) => {
            ApplicablePaymentItem.clickOnSelect(item);
          }}
          onChange={(e) => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  static clickOnSelect(item) {
    alert('Click');
  }
}
